{
  "checkoutCart": {
    "forexAdjustmentLabel": "Dollar conversion difference",
    "ownedPlansTitle": "Your Plans",
    "currentPlanTitle": "Current Plan",
    "newPlanTitle": "New plan",
    "newAddOnTitle": "Adding To Your Plan",
    "endsOn": "Ends on {0}",
    "emptyState": "Nothing added to cart",
    "checkoutButton": "Checkout",
    "summaryLabel": "To pay now",
    "renewsAt": "Renews at {0}/{1}",
    "renewsOn": "Renews on {0}",
    "invoiceNote": "See full breakdown in your invoice.",
    "unusedDaysCredit": {
      "label": "Unused time on current plan ({0} days)",
      "value": "Applied as discount."
    }
  }
}
